export function isOnServer(): boolean {
  return typeof window === 'undefined';
}
